import * as colorify from 'lottie-colorify'
import lottie from 'lottie-web'

export default function useLottie(element, rawAnimationData, options = { gsap: {} }) {
  if (!element) {
    throw new Error('No element provided to useLottie()')
  }

  // Lottie mutates the original animation data so we need to create a copy.
  let animationData = structuredClone(rawAnimationData)

  const playhead = { frame: 0 }

  if ('color' in options) {
    animationData = colorify.flatten(options.color, animationData)
  }

  if ('replaceColorAtIndex' in options) {
    const originalColors = colorify.getColors(animationData)
    Object.entries(options.replaceColorAtIndex).forEach(([index, color]) => {
      animationData = colorify.replaceColor(originalColors[index], color, animationData)
    })
  }

  const lottieAnimation = lottie.loadAnimation({
    container: element,
    renderer: options.renderer || 'canvas',
    loop: false,
    autoplay: false,
    animationData,
  })

  let lastFrame = -1
  const gsapAnimation = {
    frame: lottieAnimation.totalFrames - 1,
    duration: lottieAnimation.getDuration(),
    ease: 'none',
    onUpdate: () => {
      const frame = Math.floor(playhead.frame)
      if (frame === lastFrame) {
        return
      }
      lastFrame = frame
      lottieAnimation.goToAndStop(frame, true)
    },
    ...(options.gsap || {}),
  }

  onUnmounted(() => {
    lottieAnimation.destroy()
  })

  return {
    element,
    playhead,
    animation: gsapAnimation,
  }
}
